import { render, staticRenderFns } from "./ClientsEdit.vue?vue&type=template&id=56dec28d&"
import script from "./ClientsEdit.vue?vue&type=script&lang=js&"
export * from "./ClientsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports